import React, { Component } from 'react';
import { Link } from "react-router-dom";

class InvalidResetPasswordLink extends Component {
  render () {
    return (
      <div>
        <h1>Your password reset link is invalid or has expired.</h1>
        <h2>Go to <Link to="/auth/reset_password_request">Forgot password</Link> page</h2>
      </div>
    );
  }
}

export default InvalidResetPasswordLink;


// WEBPACK FOOTER //
// ./src/components/pages/reset_password/invalid_link.js